export { default as ArticlePageHeader } from './ArticlePageHeader/ArticlePageHeader';
export { default as ArticleTOC } from './ArticleTOC/ArticleTOC';
export { default as Author } from './Author/Author';
export { default as authorAdapter } from './Author/adapter';
